export default {
    it: {
        "thank-you-pt1": "Grazie, abbiamo appena inviato una mail riepilogativa all'indirizzo che hai indicato: ",
        "thank-you-pt2": ". Sarai contattato dai nostri operatori nel più breve tempo possibile.",
        "attention": "ATTENZIONE: I ticket che non vengono confermati attraverso il link presente nell'email riepilogativa non saranno presi in carico dal sistema, perciò controlla subito la tua casella di posta elettronica.",

    },
    en: {
        "thank-you-pt1": "Thank you, we have just sent a summary email to the address you indicated: ",
        "thank-you-pt2": ". You will be contacted by our operators as soon as possible",
        "attention": "ATTENTION: Tickets that are not confirmed through the link in the summary email will not be taken over by the system, so check your email box immediately.",

    }
}